import { navigateMediaItem } from '@/helpers/navigateMediaItem';

export const updateCtaButtonAction = (wrapper) => {
  const ctaButton = wrapper.querySelector('.ctaFrame');
  const textWrapper = ctaButton.querySelector('.text-wrapper');
  const contents = navigateMediaItem();
  const currentContent = contents[window.moviePosition];
  const ctaButtonText = currentContent?.ctaText || '';
  ctaButton.style.visibility = 'hidden';

  const mediaElements = wrapper.querySelectorAll('img.storeeel-media-image, video.storeeel-movie');

  const visibleMedia = Array.from(mediaElements).find(el => {
    return getComputedStyle(el).display !== 'none';
  });
  if (visibleMedia && ctaButtonText !== '') {
    if (visibleMedia.tagName === 'IMG') {
      // 画像の読み込み完了時
      if (visibleMedia.complete) {
        ctaButton.style.visibility = 'visible';
      } else {
        visibleMedia.addEventListener('load', () => {
          ctaButton.style.visibility = 'visible';
        }, { once: true });
      }
    } else if (visibleMedia.tagName === 'VIDEO') {
      // 動画のメタデータ読み込み完了時
      visibleMedia.addEventListener('loadedmetadata', () => {
        ctaButton.style.visibility = 'visible';
      }, { once: true });
    }
  }

  if (ctaButton) {
    textWrapper.textContent = ctaButtonText;
  }
}
